import React, { createContext, useState, useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { io } from 'socket.io-client';
import { getNotification,setNotification,getNotificationCount,setNotificationCount } from '../Website/redux/notification';

const WebSocketContext = createContext();

export const useWebSocket = () => useContext(WebSocketContext);

export const WebSocketProvider = ({ children }) => {
    const dispatch = useDispatch();
    const [socket, setSocket] = useState(null);
    const [isConnected, setIsConnected] = useState(false);
    const [reconnectAttempts, setReconnectAttempts] = useState(0);
    // const [notifications, setNotifications] = useState([]);
    // const []


    const MAX_RECONNECT_ATTEMPTS = 100000000; 
    const user = useSelector((state) => state.customer);
    const {notificationData} = useSelector((state) => state.notification);

    // console.log(user, "userData!>>>>>>>>");
    // console.log(notificationData, "notifiactionsssss");

    // Sync Redux notifications to local state
    // useEffect(() => {
    //     if (notificationData) {
    //         setNotificationCount((prevNotifications) => [
    //             ...prevNotifications,
    //             ...Object.values(notificationData),
    //         ]);
    //     }
    // }, [notificationData]);

    useEffect(() => {
        if (user?.customer?._id) {
            connectSocket();

            return () => {
                if (socket) {
                    socket.disconnect();
                }
            };
        }
    }, [user?.customer?._id]);

    // useEffect(() => {
    //     if (user?.customer?._id) {
    //         dispatch(getNotification(user?.customer?._id));
    //     }
    // }, [user?.customer?._id]);

    useEffect(()=>{
        dispatch(getNotificationCount())
    },[notificationData])

    const connectSocket = () => {
        const socketUrl = "http://localhost:4000"; 
        // const socketUrl = "https://missy-and-moppet.universalairproducts.com"; 
        const newSocket = io(socketUrl, {
            transports: ["websocket","polling"],
            upgrade:true
        });

        console.log("newSocket--------- useeffect", newSocket);
        setSocket(newSocket);

        newSocket.on("connect", () => {
            console.log("Socket.IO connection established");
            setIsConnected(true);
            setReconnectAttempts(0);

            if (user?.customer?._id) {
                newSocket.emit("register", user?.customer?._id);
            }
        });

        newSocket.on("disconnect", (reason) => {
            console.log("Socket.IO connection disconnected. Reason:", reason);
            setIsConnected(false);

            if (reconnectAttempts < MAX_RECONNECT_ATTEMPTS) {
                setTimeout(() => {
                    console.log("Attempting to reconnect to Socket.IO...");
                    setReconnectAttempts((prev) => prev + 1);
                    connectSocket();
                }, 2000);
            } else {
                console.log("Max reconnection attempts reached");
            }
        });

        newSocket.on("connect_error", (error) => {
            console.log("Socket.IO connection error:", error);
        });

        newSocket.on("notification", (notification) => {
            console.log("notificationQQ:", notification);
            dispatch(setNotification(notification));
        });

        return () => {
            newSocket.off("connect");
            newSocket.off("disconnect");
            newSocket.off("connect_error");
            newSocket.off("notification");
            newSocket.off("newCommentToast");
            newSocket.off("updateOnlineUsers");
            newSocket.close();
        };
    };

    return (
        <WebSocketContext.Provider value={{ socket, isConnected }}>
            {children}
        </WebSocketContext.Provider>
    );
};
